import React, { useEffect } from 'react';
// import { useIdHash } from '../hooks/custom.hooks';
import { useNavigateRoute } from '../hooks/custom.hooks';

function NavigationWrapper(props) {
  const navigateRoute = useNavigateRoute();
  // const { isApp } = useIdHash();
  useEffect(() => {
    const handlePopstate = (event) => {
      event.preventDefault();
      navigateRoute({ goBack: true, avoidNavigation: true });
    };
    window.addEventListener('popstate', handlePopstate);
    return () => window.removeEventListener('popstate', handlePopstate);
  }, [navigateRoute]);

  // useEffect(() => {
  //   if (isApp) {
  //     window.addEventListener('beforeunload', function () {
  //       localStorage.removeItem('routerStack');
  //     });
  //   }
  // }, [isApp]);

  return <>{props.children}</>;
}

export default React.memo(NavigationWrapper);
